var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"container",style:({
  width:((_vm.position.width) + "px"),
  height:((_vm.position.height) + "px"),
  top:((_vm.position.top) + "px"),
  left:((_vm.position.left) + "px")
})})}
var staticRenderFns = []

export { render, staticRenderFns }